export default __webpack_public_path__ + "static/media/careers.7aade171.jpg";